export function getInpaintMaskImage(sendMessage, base64) {
  return new Promise((resolve, reject) => {
    window.returnInpaintMaskTexture = (msg) => {
      console.log('getInpaintMaskImage====', msg);
      resolve(msg);
    };
    sendMessage('ContextManager', 'OnCmdExec', 'RegulateTexWithMask ' + base64);
  });
}

export function inpaintOriginal(sendMessage, brush) {
  sendMessage('ContextManager', 'OnCmdExec', 'brushOpen ' + (brush ? 0 : 1));
}

export function inpaintDraw(sendMessage, onInpaint) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnInpaint ' + (onInpaint ? 0 : 1));
}

export function inpaintErase(sendMessage, open) {
  sendMessage('ContextManager', 'OnCmdExec', 'onInpaintErase ' + open);
}

// 清除重绘制
export function clearInpainting(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnInpaintClear 1');
}

// 删除重绘制
export function deleteInpainting(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'ClearVirtual');
}

// 生成2D
export function gen2D(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'Gen2D');
  // setTimeout(() => {
  SetLoading(sendMessage, 0);
  // }, 200);
}

export function getInpaintTextures(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'GetInpaintTextures');
}

// 设置加载进度
export function SetLoading(sendMessage, val) {
  sendMessage('ContextManager', 'OnCmdExec', 'SetLoading ' + val);
}

// 取消生成
export function OnCancelGenerate(sendMessage) {
  sendMessage('ContextManager', 'OnCmdExec', 'OnCancelGenerate');
}
